import ErrorHandler from '@module/error-handler';

export const init = () => {
  ErrorHandler.configure();
};
